module.exports = __webpack_public_path__ + "img/HZGB02-03-02.c437671.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/HZGB02-03-02.png
// module id = Bt70
// module chunks = 0